"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var pageLoad_constant_1 = require("../constants/pageLoad.constant");
var PageLoadDataService = (function () {
    function PageLoadDataService() {
    }
    PageLoadDataService.buildPageName = function (data) {
        var domain = data.domain || this.getDomainFromHostname();
        var siteSection2 = data.siteSection2 || 'xx';
        var subPage1 = data.subPage1 || 'xx';
        var subPage2 = data.subPage2 || 'xx';
        return "".concat(pageLoad_constant_1.default.countryCode, ":").concat(pageLoad_constant_1.default.language, ":").concat(pageLoad_constant_1.default.siteDescriptor, ":").concat(pageLoad_constant_1.default.platform, ":").concat(domain, ":").concat(data.siteSection1, ":").concat(siteSection2, ":").concat(subPage1, ":").concat(subPage2);
    };
    PageLoadDataService.identifySite = function (isInternal) {
        return isInternal ? 'fasi' : 'fas';
    };
    PageLoadDataService.getDomainFromHostname = function () {
        var hostnameDomain = window.location.hostname.split('.')[0];
        if (hostnameDomain === 'www') {
            hostnameDomain = window.location.hostname.split('.')[1];
        }
        return hostnameDomain;
    };
    PageLoadDataService.buildPageData = function (data) {
        var pageUrl = document.URL;
        var isInternal = pageUrl.indexOf('fasi') > -1;
        var adobePageData = {
            pageTitle: document.title,
            pageName: PageLoadDataService.buildPageName(data),
            platform: pageLoad_constant_1.default.platform,
            siteSection1: data.siteSection1,
            siteSection2: data.siteSection2,
            siteIdentifier: PageLoadDataService.identifySite(isInternal),
            is404: data.is404 || pageLoad_constant_1.default.is404,
            pageTemplate: data.pageTemplate,
            DLVersion: pageLoad_constant_1.default.DLVersion
        };
        if (data.sitespectID) {
            adobePageData.sitespectID = data.sitespectID;
        }
        if (data.abCohortTesting) {
            adobePageData.abCohortTesting = data.abCohortTesting;
        }
        return adobePageData;
    };
    return PageLoadDataService;
}());
exports.default = PageLoadDataService;
//# sourceMappingURL=PageLoadDataService.js.map